import { css } from 'styled-components';

/** 스크롤은 유지하고 스크롤바만 숨김 (페이지 본문용) */
export const hideScrollbar = css`
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
`;
